import type { Release } from '../releases.ts';

export default {
  version: '0.10.0',
  date: '2026-10-02',
  title: 'Fixes and housekeeping',
  summary: [
    'The version and its history are shown in the app',
    'Delete storage agents, and single copies of a file',
    'System status groups services and shows CPU and memory per instance',
    'Asset categories are now Asset classes',
    'Fixed: sign-ins wait after repeated wrong passwords',
    'Fixed: storage agents report the real free and total space',
  ],
  features: [
    'The version and this history are shown in the app',
    'Storage agents can be deleted (after a warning; refused while PRISM keeps files in their folders)',
    'Delete a single copy of a file from the asset’s Storage tab (never the last copy of an original)',
    'System status → Services groups services by what they do, explains each, and shows CPU and memory use per instance and worker replica',
    'Asset categories are now Asset classes; after ingest, only administrators and media managers change an asset’s class (new permission “Set asset classes”)',
  ],
  fixes: [
    'Sign-in throttling: after repeated wrong passwords for an account, or from one address, sign-ins wait',
    'Exports from originals in S3 or OCI buckets: the sources are copied to the worker before rendering',
    'Storage agents and server folders report the real free and total space (a Mac running Docker showed 127 TB for a 494 GB disk)',
    'Multicam with three or more angles plays smoothly: a slow angle is waited for instead of being re-seeked over and over, small drift is taken up by speed, and the timecode follows the live angle',
  ],
} satisfies Release;
